// A combobox's `required` sits on its hidden input, where the browser refuses to
// submit in silence: this shows the message on the visible half.
import { Controller } from "stimulus"

export default class extends Controller {
  check(event) {
    const form = this.element
    if (form.checkValidity()) return

    const culprit = [...form.elements].find(field => field.willValidate && !field.checkValidity())
    if (!culprit) return

    event.preventDefault()

    const shown = this._visibleTwin(culprit)
    shown.scrollIntoView({ block: "center", behavior: "smooth" })

    if (shown === culprit) return form.reportValidity()

    // Borrowed from the hidden input, and given back as soon as the person types.
    shown.setCustomValidity(culprit.validationMessage)
    shown.reportValidity()
    const clear = () => shown.setCustomValidity("")
    shown.addEventListener("input", clear, { once: true })
    shown.addEventListener("change", clear, { once: true })
  }

  _visibleTwin(field) {
    if (field.offsetParent) return field

    const group = field.closest(".form-group") || field.parentElement
    const twin  = group && [...group.querySelectorAll("input, select, textarea")]
      .find(candidate => candidate.offsetParent && !candidate.disabled)

    return twin || field
  }
}
